/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useMemo } from 'react';
import { StyleSheet, View, Dimensions, TouchableOpacity } from 'react-native';
import Toast from 'react-native-toast-message';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { currency } from '@global/helpers';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import SelectBox from '@components/form/SelectBox';
import ModalFull from '@components/modal/ModalFull';
import { Loader, KeyboardWrapper } from '@components/screen/Layout';

import { MsCatalog } from '@api/ms-catalog';
import { MsOrder } from '@api/ms-order';
import PropTypes from 'prop-types';

const propTypes = {
  data: PropTypes.object,
  withoutDiscount: PropTypes.bool,
  withoutPrice: PropTypes.bool,
  withoutQuantity: PropTypes.bool,
  textWidth: PropTypes.number,
  showRemove: PropTypes.bool,
  isShowStock: PropTypes.bool,
  orderStatus: PropTypes.string,
  isDetail: PropTypes.bool,
  orderId: PropTypes.string,
  promotionRules: PropTypes.array,
  onSelectPromo: PropTypes.func,
  onCancelPromo: PropTypes.func,
  onReady: PropTypes.func,
  onShow: PropTypes.func,
  onRemove: PropTypes.func,
};

const defaultProps = {
  data: {},
  withoutDiscount: false,
  withoutPrice: false,
  withoutQuantity: false,
  textWidth: 0,
  showRemove: false,
  isShowStock: false,
  orderStatus: '',
  isDetail: false,
  orderId: '',
  promotionRules: [],
  onSelectPromo: () => {},
  onCancelPromo: () => {},
  onReady: () => {},
  onShow: () => {},
  onRemove: () => {},
};

const dimension = Dimensions.get('window');
const fullWidth = dimension.width;
const imageSize = 40;
const trash = {
  width: 14,
  height: 18,
};
const icon = 12;

const ProductItem = (props) => {
  const {
    data = {},
    withoutDiscount = false,
    withoutPrice = false,
    withoutQuantity = false,
    textWidth = 0,
    showRemove = false,
    isShowStock = false,
    orderStatus = '',
    isDetail = false,
    orderId = '',
    promotionRules = [],
    onSelectPromo = () => {},
    onCancelPromo = () => {},
    onReady = () => {},
    onShow = () => {},
    onRemove = () => {},
  } = props;

  const item = data || {};
  const isSelectedRules = Boolean(item?.applied_promotion?.id);
  // const productPromotion = promotionRules.filter((d) => {
  //   return (
  //     (d?.rules?.products?.length
  //       ? d.rules.products.findIndex((d1) => d1.id == item.id) > -1
  //       : // eslint-disable-next-line no-constant-condition
  //       true || d?.rules?.brands?.length
  //       ? d.rules.brands.findIndex((d1) => d1.id == item.brand.id) > -1
  //       : // eslint-disable-next-line no-constant-condition
  //       true || d?.rules?.categories?.length
  //       ? d.rules.categories.findIndex((d1) => d1.id == item?.category?.id) > -1
  //       : true || d?.is_applicable_for_all_products) &&
  //     (d.promotion_model == 'buy_x_get_x_and_buy_x_get_y'
  //       ? d?.rules?.products?.length
  //         ? Number(data.quantity) >= Number(d.rules.products[0].quantity)
  //         : false
  //       : true)
  //   );
  // });

  useEffect(() => {
    if (!withoutDiscount && isSelectedRules) {
      onReady();
    }
  }, [promotionRules]);

  const onShowProduct = (item) => {
    try {
      onShow(item);
    } catch (error) {}
  };

  const onRemoveProduct = (item) => {
    try {
      onRemove(item);
    } catch (error) {}
  };

  return (
    <View style={{ width: '100%' }}>
      <Product
        product={item}
        isSelectedRules={isSelectedRules}
        showRemove={showRemove}
        withoutPrice={withoutPrice}
        withoutQuantity={withoutQuantity}
        textWidth={textWidth}
        // productPromotion={productPromotion}
        withoutDiscount={withoutDiscount}
        isShowStock={isShowStock}
        orderStatus={orderStatus}
        isDetail={isDetail}
        orderId={orderId}
        onShowProduct={(val) => onShowProduct(val)}
        onRemoveProduct={() => onRemoveProduct()}
        onSelectPromo={(val) => onSelectPromo(val)}
        onCancelPromo={() => onCancelPromo()}
      />
      {isSelectedRules && item?.free_product?.id ? (
        <Product
          isFreeProduct
          product={item.free_product}
          isSelectedRules={isSelectedRules}
          showRemove={showRemove}
          withoutPrice={withoutPrice}
          withoutQuantity={withoutQuantity}
          textWidth={textWidth}
          // productPromotion={productPromotion}
          withoutDiscount={withoutDiscount}
          isShowStock={isShowStock}
          orderStatus={orderStatus}
          orderId={orderId}
          onShowProduct={(val) => onShowProduct(val)}
          onRemoveProduct={() => onRemoveProduct()}
          onSelectPromo={(val) => onSelectPromo(val)}
          onCancelPromo={() => onCancelPromo()}
        />
      ) : (
        false
      )}
    </View>
  );
};

const Product = ({
  product = {},
  showRemove,
  isShowStock,
  orderStatus,
  isDetail,
  orderId,
  withoutPrice = false,
  withoutQuantity = false,
  textWidth = 0,
  // productPromotion,
  withoutDiscount,
  isFreeProduct = false,
  onShowProduct = () => {},
  onRemoveProduct = () => {},
  onSelectPromo = () => {},
  onCancelPromo = () => {},
}) => {
  const [promoLoading, setPromoLoading] = useState(false);
  const [productName, setProductName] = useState('');
  const [promotionProducts, setPromotionProducts] = useState([]);

  const getPromotionLists = async (product) => {
    if (!promoLoading) {
      setProductName(product?.name);
      setPromoLoading(true);
      try {
        const promotions = await MsOrder.getProductPromotion(
          orderId,
          product?.id,
          product?.combination?.id,
        );
        if (promotions?.data?.data?.length) {
          setPromotionProducts(promotions.data.data);
        } else {
          setPromotionProducts([]);
        }
        setPromoLoading(false);
      } catch (error) {
        setPromoLoading(false);
      }
    }
  };

  const closeProductPromo = () => {
    setProductName('');
    setPromoLoading(false);
    setPromotionProducts([]);
  };

  const isLessQuantity = (pr) => {
    const qty =
      pr.quantity && !isNaN(Number(pr.quantity)) ? Number(pr.quantity) : 0;
    const stock =
      pr.stock_available && !isNaN(Number(pr.stock_available))
        ? Number(pr.stock_available)
        : 0;
    return qty > stock;
  };

  const isLessStock = isShowStock && isLessQuantity(product);
  const isSelectedRules = Boolean(product?.applied_promotion?.id);
  // const isAvailablePromo = Boolean(productPromotion?.length && product.is_promo_available);
  const isAvailablePromo = Boolean(product.is_promo_available);
  const productImage = product?.combination?.image
    ? product.combination.image
    : product.image;

  const mobileWrapperWidth = textWidth ? textWidth : fullWidth - 80;
  const mobileWidth = fullWidth - 130;

  const realPrice = product.total_price_before_tax / product.quantity;
  const finalPrice = product.return_quantity * realPrice;

  const RenderImage = useMemo(
    () => (
      <Image
        style={{ width: imageSize, height: imageSize }}
        width={imageSize}
        height={imageSize}
        compressWidth={imageSize}
        source={productImage}
      />
    ),
    [productImage],
  );

  if (product.return_quantity > 0) {
    return (
      <TouchableOpacity
        onPress={() => (isFreeProduct ? null : onShowProduct(product))}
        activeOpacity={isFreeProduct ? 1 : 0.6}
        style={[
          {
            flexDirection: 'row',
            borderBottomColor: Colors.grey0,
            borderBottomWidth: 1,
            paddingVertical: 17,
            paddingHorizontal: 15,
            maxWidth: isWeb ? '100%' : fullWidth,
            backgroundColor: Colors.white,
          },
          isFreeProduct ? { backgroundColor: Colors.blue5 } : {},
          isLessStock ? { backgroundColor: Colors.white } : {},
        ]}>
        <View style={styles.imageWrapper}>{RenderImage}</View>
        <View
          style={{ width: isWeb ? 'calc(100% - 45px)' : mobileWrapperWidth }}>
          {isFreeProduct ? (
            <SociollaText
              type="medium"
              numberOfLines={1}
              ellipsizeMode="tail"
              style={{
                maxWidth: isWeb ? 'calc(100% - 45px)' : mobileWidth,
                fontSize: 14,
                marginBottom: 10,
              }}>
              FREE
            </SociollaText>
          ) : (
            false
          )}
          <View
            style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <SociollaText
              type="medium"
              numberOfLines={1}
              ellipsizeMode="tail"
              style={{
                maxWidth: isWeb ? 'calc(100% - 45px)' : mobileWidth,
                fontSize: 14,
              }}>
              {product?.combination?.reference
                ? `[${product.combination.reference}] `
                : product?.sku
                ? `[${product.sku}] `
                : ``}
              {product.name}
            </SociollaText>
            {showRemove && !isFreeProduct ? (
              <TouchableOpacity
                style={{
                  width: 30,
                  height: trash.height,
                  justifyContent: 'flex-end',
                }}
                activeOpacity={0.6}
                onPress={() => onRemoveProduct()}>
                <Image
                  style={{
                    width: trash.width,
                    height: trash.height,
                    alignSelf: 'flex-end',
                    marginRight: 10,
                  }}
                  width={trash.width}
                  height={trash.height}
                  source={require('@assets/img/icons/trash-grey.svg')}
                  svg={true}
                />
              </TouchableOpacity>
            ) : (
              false
            )}
          </View>
          <SociollaText
            style={{ fontSize: 13, color: Colors.grey1, marginVertical: 10 }}>
            {product.brand && product.brand.name ? product.brand.name : '-'}
          </SociollaText>
          {!withoutPrice ? (
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
              }}>
              <View>
                {!withoutQuantity ? (
                  <View>
                    <SociollaText
                      style={{
                        fontSize: 13,
                        color: Colors.grey1,
                        marginBottom: 8,
                      }}>
                      Net Delivered {product.net_delivered_qty} Pcs
                    </SociollaText>
                    <SociollaText style={{ fontSize: 13, color: Colors.grey1 }}>
                      Return QTY {product.return_quantity} Pcs
                    </SociollaText>
                  </View>
                ) : (
                  false
                )}
              </View>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                {!isDetail &&
                !isFreeProduct &&
                product.is_promo_reminder &&
                !product?.discount_percentage2?.id &&
                !isSelectedRules ? (
                  <TouchableOpacity
                    activeOpacity={0.6}
                    style={{ marginRight: 15, marginTop: -2 }}
                    onPress={() => getPromotionLists(product)}>
                    <Image
                      style={{
                        width: 14,
                        height: 14,
                      }}
                      width={14}
                      height={14}
                      source={require('@assets/img/icons/info-blue.svg')}
                      svg={true}
                    />
                  </TouchableOpacity>
                ) : (
                  false
                )}
                <SociollaText style={{ fontSize: 14 }}>
                  {currency(isFreeProduct ? 0 : finalPrice, true)}
                </SociollaText>
              </View>
            </View>
          ) : (
            false
          )}
          {!isFreeProduct &&
          !withoutDiscount &&
          (isSelectedRules || isAvailablePromo) ? (
            <View style={{ width: '100%', marginTop: 10 }}>
              {isSelectedRules ? (
                <TouchableOpacity
                  activeOpacity={0.6}
                  style={{ flexDirection: 'row', alignItems: 'center' }}
                  onPress={() => onCancelPromo()}>
                  <Image
                    style={{
                      width: icon,
                      height: icon,
                      marginRight: 10,
                      marginTop: -3,
                    }}
                    width={icon}
                    height={icon}
                    source={require('@assets/img/icons/close-blue.svg')}
                    svg={true}
                  />
                  <SociollaText style={styles.promoLabel}>
                    Promo Applied: {product?.applied_promotion?.name}
                  </SociollaText>
                </TouchableOpacity>
              ) : (
                <View style={{ width: '100%' }}>
                  <View
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      marginBottom: 10,
                    }}>
                    <Image
                      style={{
                        width: icon,
                        height: icon,
                        marginRight: 10,
                        marginTop: -3,
                      }}
                      width={icon}
                      height={icon}
                      source={require('@assets/img/icons/info-blue.svg')}
                      svg={true}
                    />
                    <SociollaText style={styles.promoLabel}>
                      Promo Available
                    </SociollaText>
                  </View>
                  <View style={{ width: isWeb ? '50%' : '100%' }}>
                    <SelectBox
                      label="Select Promotion"
                      hideLabel={true}
                      // options={productPromotion}
                      value={product?.applied_promotion}
                      placeholder="Select Promotion"
                      trackBy="id"
                      labelKey="name"
                      onChange={async (value) => {
                        if (value?.id) {
                          const freeProduct =
                            value?.discount_info?.free_products;
                          const getProductDetail = async (id) => {
                            if (id) {
                              const response = await MsCatalog.getProductDetail(
                                id,
                              );
                              if (response?.data?.data?.combinations?.length) {
                                const data = response.data.data.combinations;
                                const com = data.find(
                                  (item) =>
                                    item._id == freeProduct?.combination_id,
                                );
                                if (com?.price) {
                                  return com.price;
                                }
                              }
                            }
                            return 0;
                          };
                          const price = await getProductDetail(freeProduct?.id);

                          const qty = Number(product?.quantity || 0);
                          const purchased_product = value?.rules?.products
                            ?.length
                            ? value.rules.products[0]
                            : {};
                          const purchased_product_qty = Number(
                            purchased_product?.quantity || 0,
                          );
                          const free_product = value?.discount_info
                            ?.free_products?.id
                            ? value.discount_info.free_products
                            : {};
                          const free_product_qty = Number(
                            free_product?.quantity || 0,
                          );
                          const round_qty = Math.floor(
                            qty / purchased_product_qty,
                          );
                          const final_free_product_qty = Number(
                            round_qty * free_product_qty,
                          );

                          if (final_free_product_qty > 0) {
                            if (
                              product?.free_product?.quantity !=
                              final_free_product_qty
                            ) {
                              freeProduct.quantity = final_free_product_qty;
                              if (
                                value?.maximum_qty_order &&
                                Number(value.maximum_qty_order || 0) <
                                  final_free_product_qty
                              ) {
                                freeProduct.quantity = Number(
                                  value.maximum_qty_order,
                                );
                              }
                            }

                            onSelectPromo({
                              id: value.id,
                              name: value.name,
                              product: {
                                id: freeProduct?.id,
                                name: freeProduct?.name,
                                brand: freeProduct?.brand,
                                combination_id: freeProduct?.combination_id,
                                sku: freeProduct?.sku,
                                image: freeProduct?.image,
                                quantity: freeProduct?.quantity,
                                price: price,
                              },
                            });
                          } else {
                            onCancelPromo();
                            Toast.show({
                              text1: `Promotion ${value.name} is not valid for this product.`,
                              type: 'error',
                            });
                          }
                        }
                      }}
                    />
                  </View>
                </View>
              )}
            </View>
          ) : (
            false
          )}
        </View>
        <ModalFull
          title={`Promo ${productName}`}
          show={Boolean(productName)}
          onClose={() => closeProductPromo()}>
          {promoLoading ? (
            <View style={{ padding: 20 }}>
              <Loader />
            </View>
          ) : promotionProducts?.length ? (
            <View style={{ marginTop: isWeb ? 5 : 0 }}>
              <KeyboardWrapper>
                {promotionProducts.map((item, idx) => (
                  <View
                    style={[
                      styles.promoItem,
                      idx == 0
                        ? { borderTopColor: Colors.grey0, borderTopWidth: 1 }
                        : {},
                      isWeb && idx == promotionProducts.length - 1
                        ? { borderBottomWidth: 0 }
                        : {},
                    ]}
                    key={`promo-product-${idx}`}>
                    <SociollaText
                      style={[
                        styles.promoText,
                        { width: 25, marginRight: 10 },
                      ]}>
                      {idx + 1}.
                    </SociollaText>
                    <SociollaText style={styles.promoText}>
                      {item?.description ? item.description : '-'}
                    </SociollaText>
                  </View>
                ))}
              </KeyboardWrapper>
            </View>
          ) : (
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 20,
              }}>
              <SociollaText style={styles.promoText}>
                Belum ada promo untuk produk ini.
              </SociollaText>
            </View>
          )}
        </ModalFull>
      </TouchableOpacity>
    );
  } else {
    return <View></View>;
  }
};

const styles = StyleSheet.create({
  imageWrapper: {
    backgroundColor: Colors.white,
    justifyContent: 'center',
    marginRight: 10,
    overflow: 'hidden',
    width: imageSize,
    height: imageSize,
  },
  promoLabel: {
    width: '100%',
    fontSize: 13,
    flexDirection: 'row',
    alignItems: 'center',
    color: Colors.blue0,
  },
  promoText: { fontSize: 13 },
  promoItem: {
    flexDirection: 'row',
    padding: 15,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
});

ProductItem.propTypes = propTypes;
ProductItem.defaultProps = defaultProps;

export default ProductItem;
